import styled from "styled-components";

export const ContainerCardUser = styled.div`
  display: flex;
  word-break: break-word;
  width: 100%;
 
`;

export const InformationCardUser = styled.div`
  display: flex;
  width: 100%;
  word-break: break-word;
  flex-direction: column;
  margin-left: 5px;
`;

export const TitleWelcome = styled.label`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: -0.02em;

  color: #575757;
`;

export const TitleName = styled.label`
font-family: 'Inter';
font-style: normal;
font-weight: 600;
font-size: 28px;
line-height: 36px;
/* identical to box height, or 129% */

letter-spacing: -0.02em;

color: #575757;

`;
